module.exports = __webpack_public_path__ + "static/media/Brood.b6668354.svg";